export default __webpack_public_path__ + "static/media/USD+.bf3aa5fa.png";